import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { ChevronRight, Plus } from 'lucide-react';
import { Button } from '@/shared/components';
import type { FlatFamilyMember, ObjectApartmentSummary } from '@/shared/api';
import { WholeFlatLinkFlow } from './WholeFlatLinkFlow';

interface Props {
  wholeFlatId: string;
  wholeFlatName: string;
  rooms: FlatFamilyMember[];
  /** Apartments desselben Objekts; null, solange die Objektliste fehlt. */
  apartments: ObjectApartmentSummary[] | null;
  manageable: boolean;
}

/** Eine Gesamtwohnung: ihre Zimmer als Wege zu deren Akte, dazu „Zimmer hinzufügen“. */
export function WholeFlatRooms({
  wholeFlatId,
  wholeFlatName,
  rooms,
  apartments,
  manageable,
}: Props) {
  const [adding, setAdding] = useState(false);

  return (
    <div className="mt-4">
      <p className="text-ink text-sm">
        Gesamtwohnung mit {rooms.length} {rooms.length === 1 ? 'Zimmer' : 'Zimmern'}.
      </p>
      <ul className="border-line divide-line/60 mt-3 divide-y rounded-md border">
        {rooms.map((room) => (
          <li key={room.id}>
            <Link
              to="/properties/$id/stammdaten"
              params={{ id: room.id }}
              className="hover:bg-card-alt/50 focus-visible:ring-sage flex min-h-11 items-center gap-3 px-3 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
            >
              <span
                className="text-ink min-w-0 flex-1 truncate text-sm font-medium"
                title={room.adminDisplayName}
              >
                {room.adminDisplayName}
              </span>
              <ChevronRight size={16} className="text-ink-faint shrink-0" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
      {manageable && apartments && !adding && (
        <Button
          type="button"
          variant="link"
          className="mt-3 min-h-11 px-0 text-[13px]"
          leftIcon={<Plus size={14} aria-hidden />}
          onClick={() => setAdding(true)}
        >
          Zimmer hinzufügen
        </Button>
      )}
      {manageable && apartments && adding && (
        <WholeFlatLinkFlow
          mode="addRoom"
          propertyId={wholeFlatId}
          propertyName={wholeFlatName}
          apartments={apartments}
          onDone={() => setAdding(false)}
          onCancel={() => setAdding(false)}
        />
      )}
    </div>
  );
}
